import { ReactNode } from "react";

interface AuthenticationBackgroundProps {
    children: ReactNode
}

export default function AuthenticationBackground(props: AuthenticationBackgroundProps){
    const { children } = props;
    const opacity = 0.5;

    return (
        <div style={{
                background: `linear-gradient( rgba(0, 0, 0, ${opacity}), rgba(0, 0, 0, ${opacity}) ), url("/bg-accelist-career.jpg")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}
        >
            {children}
        </div>
    );
}